module.exports = __webpack_public_path__ + "img/beatout-logo.50777bc6.svg";